import { useUserInfo } from 'pages/Header/Content/hooks/usePersonalData'
import { useLogout } from 'newHooks/useLogin'
import styles from './styles.module.sass'


const FloatMenuSession = () => {
    const { profileGet:profileData } = useUserInfo()
    const { logOut } = useLogout()
    const name = profileData?.nombre

    return(
        <div className={styles?.contUser}>
            <p className={styles?.textWelcome}>Bienvenido</p>
            <p className={styles?.textName}>{name}</p>
            <div className={styles?.box__login} id="box__login">
                <dl>
                    <dt>
                        <div>
                            <a href="/mi-cuenta"> Entrar a mi cuenta</a>
                        </div>
                    </dt>
                    <dt>
                        <div>
                            <a href="/mi-cuenta/mis-pedidos/dias=30/pagina=1">Revisar mis pedidos</a>
                        </div>
                    </dt>
                </dl>
                <dl className={styles?.logOut}>
                    <dt>
                        <p>¿ No eres {name} ?</p>
                        <div className={styles?.cerrar} onClick={logOut} aria-hidden>Cerrar mi sesión</div>
                    </dt>
                </dl>
            </div>
        </div>
    )
}

export default FloatMenuSession